import { render, staticRenderFns } from "./itemSelectPop.vue?vue&type=template&id=853d539a&scoped=true&"
import script from "./itemSelectPop.vue?vue&type=script&lang=js&"
export * from "./itemSelectPop.vue?vue&type=script&lang=js&"
import style0 from "./itemSelectPop.vue?vue&type=style&index=0&id=853d539a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853d539a",
  null
  
)

export default component.exports